// extracted by mini-css-extract-plugin
module.exports = {"shimmer":"Shimmer_shimmer__lm2Yt","shimmer-slide":"Shimmer_shimmer-slide__3To9a"};